import ExternalRedirectHeaderStepper from './Stepper';
import styles from './styles.module.scss';
import { TransactionResultProps } from '../props';
import { useTranslation } from '../../../../hooks';

/**
 * ExternalRedirectTrail Component
 * Displays a trail/progress indicator for external redirect transactions.
 * Shows a title and stepper component to track transaction progress.
 *
 * @component
 * @param {Object} props - Component props
 * @param {TransactionType} props.transaction - The transaction object containing status and progress details
 * @returns {JSX.Element} A container with title and stepper for tracking transaction progress
 *
 * @example
 * const transaction = {
 *   id: "t123",
 *   status: { id: "pending" },
 *   progress: 50
 * };
 *
 * <ExternalRedirectTrail transaction={transaction} />
 */
export default function ExternalRedirectTrail({
  transaction,
}: TransactionResultProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <h2 className={styles.container__title}>{t('order_progress_title')}</h2>
      <ExternalRedirectHeaderStepper transaction={transaction} />
    </div>
  );
}
